import { Component, OnInit } from "@angular/core";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { ReformsService } from "../reforms.service";
import { TranslateService } from "@ngx-translate/core";
import { ScreenConstants } from "src/app/constants/screenId.constants";

@Component({
  selector: "app-list-reforms",
  templateUrl: "./list-reforms.component.html",
  styleUrls: ["./list-reforms.component.sass"],
})
export class ListReformsComponent implements OnInit {
  tableList = TableConstants.reforms;
  routing = RoutingConstants.reformsRouting;
  options = TableConstants.NotShowCreateDeleteAndArrowUpDownAndShowLabel;
  filtersTable: string;
  filtersTableJSON;
  reformsList = [];
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;

  constructor(
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private reformsService: ReformsService,
    private translateService: TranslateService
  ) {
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      "re_Id",
      ScreenConstants.admSistemas.reforms
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
  }

  ngOnInit(): void {
    this.getReformsList();
  }

  getReformsList() {
    this.reformsService.lista(this.filtersTable).subscribe(
      (data) => {
        this.reformsList = data["content"];
        this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
        this.numElements = data["numberOfElements"];
        this.totalElements = data["totalElements"];
        if (data["content"] && data["content"].length == 0) {
          let message = this.translateService.instant(
            "messages.notFoundResutls"
          );
          this.toastrAlertService.toastrWarning(message);
          this.numPages = 1;
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  mapToTable(data): any {
    data.forEach((element) => {
      element["reId"] = element.id.reId;
      element["reMarcolegal"] = element.id.reMarcolegal;
    });
    return data;
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.getReformsList();
  }
}
